// const url = 'http://192.168.33.213:8089/certificate/get-img' //图片测试地址
const url = 'https://mainnet.bityuan.com/338090/certificate/get-img' //图片正式地址

// 请求函数
export function myFetch (data){
    data =JSON.stringify(data);
    var params = {
      method: 'POST',
      body:data,
      headers: {
        'Content-Type': 'application/json',
      },
      redirect: 'follow',
    }
    return fetch(url,params).then((response) => {
      if (response.status >= 200 && response.status < 300) {
        return response
      } else {
        var error = new Error(response.statusText)
        error.response = response
        throw error
      }  
    }).then((response) => {
      return response.json()
    })
}